// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseButton_closeButton__PgQS2","small":"CloseButton_small__7HuKy"};